import React from 'react';

const CancelIcon = ({ size = 24, className = '', ...props }) => (
  <svg className={`w-6 h-6 ${className}`} width={size} height={size} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
  </svg>
);

export default CancelIcon;
